<app-spinner [show]="showSpinner"></app-spinner>
<!-- Start Page Title Area -->
<div id="bg-cover" class="page-title-area lightgray-bg  jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <h2>{{page.title}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Experience Area -->
<section class="experience-area mt-4">
    <div class="container">

        <div class="row align-items-center" *ngIf="page.image; else elseBlock">
            <div class="col-lg-6 col-md-12">
                <div class="experience-content" [innerHTML]="htmlContent">
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="experience-image">
                    <img src="{{page.image.fileUrl}}" alt="image">
                </div>
            </div>
        </div>
        <ng-template #elseBlock>
            <div class="experience-content" [innerHTML]="htmlContent">

            </div>
        </ng-template>

    </div>
</section>
<!-- End Experience Area -->

<!-- Start Become Instructor & Partner Area -->
<app-become-instructor></app-become-instructor>
<!-- End Become Instructor & Partner Area -->